module.exports = __webpack_public_path__ + "static/media/instagram.2142a5e2.svg";